<template>
	<div class="view-select">
		<button
			v-for="option in options"
			:key="option.value"
			type="button"
			class="view-select__item"
			:class="{ 'is-active': option.value === value }"
			@click="$emit('change', option.value)"
		>
			{{ option.label }}
		</button>
	</div>
</template>

<script>
export default {
	name:  'ViewSelect',
	props: {
		options: {
			type:    Array,
			default: () => [],
		},
		value: {
			type:    [String, Number],
			default: null,
		},
	},
	emits: ['change'],
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.view-select {
	display: flex;
	align-self: center;
	gap: $sp4;
	margin-bottom: $sp4;
	overflow-x: auto;
	scrollbar-width: none;
	-ms-overflow-style: none;
	-webkit-overflow-scrolling: touch;

	@include size(md-up) {
		overflow-x: initial;
		flex-wrap: wrap;
	}
}

.view-select::-webkit-scrollbar {
	display: none;
}

.view-select__item {
	padding: $sp3 $sp4;
	border: 0;
	border-radius: $border-radius--sm;
	color: var(--color-grey-400);
	background-color: var(--color-grey-950);
	transition: background-color $trans-time-fast;
	cursor: pointer;
	white-space: nowrap;

	&.is-active {
		background-color: var(--color-grey-850);
		color: var(--color-soft-white);

		body.-t-light & { // stylelint-disable-line selector-no-qualifying-type
			background-color: var(--color-hype-yellow);
			color: var(--color-text-on-hype-yellow);
		}
	}

	&:hover,
	&:focus {
		background-color: var(--color-grey-900);
	}
}
</style>
